<template v-if="customer">
  <div id="home">
    <el-container
      @keyup.enter.native="
        query.page = 1;
        load();
      "
    >
      <el-col :span="24" class="mb-3">
        <!-- Welcome -->
        <el-row>
          <el-form
            :inline="true"
            :model="query"
            :label-position="'top'"
            class="demo-form-inline"
          >
            <el-col>
              <el-form-item :label="$t('measurement.tags')">
                <el-select
                  clearable
                  filterable
                  autocomplete
                  multiple
                  allow-create
                  default-first-option
                  value-key="item"
                  v-model="query.tags"
                  :placeholder="$t('measurement.selecttags')"
                >
                  <el-option
                    v-for="item in measurementTags"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('common.macAddress')">
                <el-input v-model="query.macAddress"></el-input>
              </el-form-item>
              <el-form-item :label="$t('measurement.type')" prop="telemetry">
                <el-select v-model="query.measurementType" :placeholder="$t('common.select')" clearable   @change="changeMeasurementType()">
                  <el-option v-for="item in this.measurementTypes" :key="item" :label="$t('common.'+item)"
                    :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('measurement.measurementType')"
                v-show="false"
              >
                <el-select default-first-option v-model="query.measurementType">
                  <el-option :value="undefined" :label="'All'"></el-option>
                  <el-option :value="true" :label="'Periodic'"></el-option>
                  <el-option :value="false" :label="'Manual'"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                :label="$t('measurement.completion')"
                v-show="false"
              >
                <el-select default-first-option v-model="query.partial">
                  <el-option
                    selected="true"
                    :value="undefined"
                    :label="'All'"
                  ></el-option>
                  <el-option :value="true" :label="'Partial'"></el-option>
                  <el-option :value="false" :label="'Full'"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('measurement.result')" v-show="false">
                <el-select default-first-option v-model="query.error">
                  <el-option :value="undefined" :label="'All'"></el-option>
                  <el-option :value="false" :label="'Succes'"></el-option>
                  <el-option :value="true" :label="'Error'"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('measurement.date')">
                <el-date-picker
                  v-model="query.dateRange"
                  type="datetimerange"
                  :picker-options="pickerOptions"
                  :format="pickerOptions.format"
                  range-separator="-"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  align="right"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="' '" style="margin-top: 28px">
                <el-checkbox
                  :label="$t('measurement.onlyMine')"
                  border
                  v-model="query.onlyMine"
                ></el-checkbox>
              </el-form-item>
              <el-form-item :label="' '" style="margin-top: 28px">
                <el-checkbox
                  :label="$t('measurement.onlyuploaded')"
                  border
                  v-model="query.upload"
                ></el-checkbox>
              </el-form-item>
              <el-form-item :label="' '" style="margin-top: 28px">
                <el-checkbox
                  :label="$t('measurement.favorite')"
                  border
                  v-model="query.favorite"
                ></el-checkbox>
              </el-form-item> 
            </el-col>
          
            <el-col>
              <el-button
                type="primary"
                @click="
                  query.page = 1;
                  load();
                "
                >{{ $t("measurement.filter") }}</el-button
              >
              <el-button
                :disabled="!selectedMeasurement.length"
                type="danger"
                @click="deleteMeasurement()"
                >{{ $t("common.delete") }}</el-button
              >
            </el-col>
            <el-button
              :loading="disabledDownloadButton"
              style="position: absolute; right: 15px; top: 15px"
              size="mini"
              @click="download()"
              >{{ $t("measurement.download") }}</el-button
            >
          </el-form>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination
              layout="prev, pager, next,sizes"
              :total="searchResult.total"
              :page-sizes="pageSizes"
              :page-size.sync="query.pageSize"
              :current-page.sync="query.page"
              @current-change="load"
              @size-change="load"
            ></el-pagination>
            <!-- Table -->
          </el-col>
        </el-row>
        <el-row>
          <el-table
            v-loading="loading"
            ref="assignTable"
            @selection-change="handleSelectionChange"
            :data="searchResult.measurements"
            class="border"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="createdAt"
              :label="$t('measurement.createdAt')"
              width="150px"
            ></el-table-column>
            <el-table-column
              prop="user"
              :label="$t('common.user')"
              width="100px"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.user"
                  >{{ scope.row.user.name }} {{ scope.row.user.surname }}</span
                >
                <span v-else>No User</span>
              </template>
            </el-table-column>
            <el-table-column prop="path" :label="$t('common.point')">
              <template slot-scope="scope">
                <span v-if="scope.row.point" style="font-size: 12px">
                  <em>{{ toPath(scope.row.point) }}</em>
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="gateway"
              label="Gateway"
              width="200px"
            ></el-table-column>

            <el-table-column
              prop="measurementType"
              :label="$t('measurement.type')"
              width="100px"
            >
              <template slot-scope="scope">
                <span> {{ $t(`common.${scope.row.measurementType}`) }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('measurement.options')">
              <template slot-scope="scope">
                <router-link
                  :to="{ name: 'measurement', params: { id: scope.row.id } }"
                  >{{ $t("measurement.details") }}</router-link
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="macAddress"
              :label="$t('common.macAddress')"
            ></el-table-column>
            <el-table-column
              prop="favorite"
              :label="$t('measurement.favorite')"
              width="100px"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.favorite">
                  <em
                    class="el-icon-star-on"
                    style="font-size: 29px; color: #ffd500"
                  ></em>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: right">
            <el-pagination
              layout="prev, pager, next,sizes"
              :total="searchResult.total"
              :page-sizes="pageSizes"
              :page-size.sync="query.pageSize"
              :current-page.sync="query.page"
              @current-change="load"
              @size-change="load"
            ></el-pagination>
            <!-- Table -->
          </el-col>
        </el-row>
      </el-col>
    </el-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import dayjs from "dayjs-ext";
import axios from "axios";
import queryStringUtil from "query-string";
import preferences from "../util/preferences";
import treeHelper from "../util/treeHelper"

export default {
  name: "MeasurementsTab",
  components: {},

  data() {
    return {
      trendDialog: false,
      disabledDownloadButton: false,
      downloadHref: "",
      measurementTypes: ["MANUAL", "PERIODIC", "TRIGGERED"],
      selectedMeasurement: [],
      query: {
        minValueActive: false,
        maxValueActive: false,
        telemetry: "",
        minValue: null,
        maxValue: null,
        dateRange: [],
        tags: [],
        macAddress: "",
        measurementType: undefined,
        partial: undefined,
        error: undefined,
        upload: false,
        onlyMine: false,
        page: 1,
        pageSize: 10,
        activeTags: [],
        favorite: false,
      },
      pageSizes: [10, 25, 50, 75],
      macAddress: [],
      pickerOptions: {
        format: preferences()
          .localization.dateFormat.replace(/D/g, "d") //element ui date format require lowercase
          .replace(/Y/g, "y"),
        shortcuts: [
          {
            text: this.$t("measurement.lastWeek"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("measurement.lastthreeMonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("tree", ["activeTags", "activePoints", "paths","flatTree"]),
    ...mapState("account", ["activeTab", "customer"]),
    ...mapState("measurement", ["searchResult", "loading"]),
    ...mapState("admin", ["telemetry"]),
    measurementTags() {
      var tags = this.$store.state.measurement.tags;
      return tags.map((x) => {
        return {
          value: x,
          label: x,
        };
      });
    },
  },

  created() {
    this.getTags();
    this.query = this.$store.state.measurement.query;
    this.load();
  },
  methods: {
    toPath(id){
      console.log(id)
      return treeHelper.pointIdToPath(this.flatTree,id);
    },
    ...mapActions("tree", ["updateConfig"]),
    ...mapActions("measurement", [
      "getTags",
      "getMeasurements",
      "deleteMeasurements",
    ]),
    ...mapActions("measurement", ["getTags"]),
    handleSelectionChange(val) {
      this.selectedMeasurement = val.map((x) => x.id);
    },
    deleteMeasurement() {
      this.$confirm(this.$t("common.AreYouSure"), this.$t("common.warning"), {
        confirmButtonText: this.$t("common.warningConfirmText"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning",
      })
        .then(() => {
          this.deleteMeasurements({ query: this.selectedMeasurement }).then(
            () => {
              this.load();
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("admin.warningDeleteCancel"),
          });
        });
    },
    minTelemetryChange() {
      this.query.minValue = null;
      if (!this.query.telemetry) {
        this.query.minValueActive = false;
      }
    },
    maxTelemetryChange() {
      this.query.maxValue = null;
      if (!this.query.telemetry) {
        this.query.maxValueActive = false;
      }
    },
    changeTelemetry() {
      if (!this.query.telemetry) {
        this.query.minValueActive = false;
        this.query.maxValueActive = false;
        this.query.minValue = null;
        this.query.maxValue = null;
      }
    },
    changeMeasurementType() {
      if (!this.query.measurementType) {
        this.query.measurementType=undefined
      }
      this.load()
    },
    openTrendDialog() {
      this.query.activeTags = this.activeTags;
      this.trendDialog = true;
    },
    load() {
      if (
        this.query.minValue < this.query.maxValue ||
        !this.query.maxValueActive ||
        !this.query.minValueActive
      ) {
        this.query.points = this.activePoints;
        this.getMeasurements(this.query);
      } else {
        this.$message({
          type: "info",
          message: this.$t("admin.warningForValidationValue"),
        });
      }
    },
    download() {
      let urlString = `${
        process.env.VUE_APP_APIURL
      }/measurement/download?${this.queryString(this.query)}`;
      if (this.lastDownloadQuery == urlString && this.downloadHref) {
        return this.downloadUrl();
      }
      this.disabledDownloadButton = true;
      this.lastDownloadQuery = urlString;
      axios
        //  .get(`${process.env.VUE_APP_APIURL}/measurement/download`, {
        .get(urlString)
        .then((res) => {
          this.downloadHref = res.data.url;
          this.downloadUrl();
        })
        .finally(() => {
          this.disabledDownloadButton = false;
        });
    },
    downloadUrl() {
      var fileLink = document.createElement("a");
      fileLink.href = this.downloadHref;
      document.body.appendChild(fileLink);
      fileLink.click();
      fileLink.remove();
    },
    queryString(query) {
      var startDate = dayjs(query.dateRange[0]).format("YYYY-MM-DD HH:mm:ss");
      var endDate = dayjs(query.dateRange[1]).format("YYYY-MM-DD HH:mm:ss");
      var queryParams = {
        minValueActive: query.minValueActive,
        maxValueActive: query.maxValueActive,
        telemetry: query.telemetry,
        minValue: query.minValue,
        maxValue: query.maxValue,
        page: query.page,
        pageSize: query.pageSize,
        startDate: startDate,
        endDate: endDate,
        macAddress: query.macAddress,
        points: query.points.join(","),
        tags: query.tags.join(","),
        partial: query.partial,
        measurementType: query.measurementType,
        error: query.error,
        onlyMine: query.onlyMine,
        upload: query.upload,
        favorite: query.favorite,
      };
      return queryStringUtil.stringify(queryParams, {
        arrayFormat: "bracket",
      });
    },
  },
  watch: {
    activeTab(c) {
      if (c == "measurements") {
        this.load();
        this.updateConfig({
          showCheckbox: true,
        });
      }
    },
    activePoints() {
      if (this.activeTab == "measurements") {
        this.load();
      }
    },
  },
};
</script>
